export default {
  displayName: 'Social Media Share Banner',
  allowableParents: ['Section'],
};
